import gql from 'graphql-tag';

export const ADD_OR_UPDATE_MERIT_API_KEY = gql`
  mutation addOrUpdateMeritApiKey($companyId: String!, $apiId: String!, $apiKey: String!) {
    accounting {
      addOrUpdateMeritApiKey(companyId: $companyId, apiId: $apiId, apiKey: $apiKey)
    }
  }
`;

export const DELETE_MERIT_API_KEY = gql`
  mutation deleteMeritApiKey(
    $companyId: String!,
  ) {
    accounting {
      deleteMeritApiKey(
        companyId: $companyId,
      )
    }
  }
`;

export const LINK_MERIT_ITEMS = gql`
  mutation linkMeritItems(
    $companyId: String!,
    $meritItemsLinks: [MeritItemLinkInput!]!
  ) {
    invoicing {
      linkMeritItems(
        companyId: $companyId,
        meritItemsLinks: $meritItemsLinks
      )
    }
  }
`;

export const CREATE_INVOICE_IN_MERIT_BY_FILE_ID = gql`
  mutation createInvoiceInMeritByAFileId($companyId: String!, $aFileId: String!, $skipChecks: Boolean, $customVatNumber: String) {
    invoicing {
      createInvoiceInMeritByAFileId(companyId: $companyId, aFileId: $aFileId, skipChecks: $skipChecks, customVatNumber: $customVatNumber)
    }
  }
`;

export const SEND_CHARGE_BE_INVOICE_TO_MERIT = gql`
  mutation sendChargebeeInvoiceToMerit($chargebeeInvoiceId: String!, $forceSubmit: Boolean!) {
    accounting {
      sendChargebeeInvoiceToMerit(chargebeeInvoiceId: $chargebeeInvoiceId, forceSubmit: $forceSubmit) {
        success
        isValidationError
        meritInvoiceId
        meritBillNo
        errorMessage
        validationErrors
      }
    }
  }
`;

export const SEND_PURCHASE_INVOICE_TO_MERIT = gql`
  mutation sendPurchaseInvoiceToMerit($accountingFileId: UuidType!, $ignoreScore: Boolean) {
    accounting {
      sendPurchaseInvoiceToMerit(accountingFileId: $accountingFileId, ignoreScore: $ignoreScore) {
        success
        isValidationError
        meritInvoiceId
        meritBillNo
        errorMessage
        validationErrors
      }
    }
  }
`;

export const SEND_INCOME_PAYMENT_TO_MERIT = gql`
  mutation SendIncomePaymentToMerit($transactionId: String!) {
    accounting {
      sendIncomePaymentToMerit(transactionId: $transactionId) {
        success
        errorMessage
      }
    }
  }
`;

export const SEND_EXPENSE_PAYMENT_TO_MERIT = gql`
  mutation SendExpensePaymentToMerit($transactionId: String!) {
    accounting {
      sendExpensePaymentToMerit(transactionId: $transactionId) {
        success
        errorMessage
      }
    }
  }
`;

export const DELETE_MERIT_PAYMENT = gql`
  mutation DeleteMeritPayment($transactionId: String!) {
    accounting {
      deleteMeritPayment(transactionId: $transactionId)
    }
  }
`;

export const WRITE_OFF_MERIT_FX_DIFFERENCE = gql`
  mutation WriteOffMeritFxDifference($companyId: String!, $year: Int!, $month: Int!, $amount: Float!) {
    accounting {
      writeOffMeritFxDifference(companyId: $companyId, year: $year, month: $month, amount: $amount)
    }
  }
`;

export const SET_COUNTERPARTY_MERIT_ITEM_ID = gql`
  mutation setCounterpartyMeritItemId($clientId: String!, $meritItemId: String!) {
    invoicing {
      setCounterpartyMeritItemId(clientId: $clientId, meritItemId: $meritItemId)
    }
  }
`;

export const REMOVE_COUNTERPARTY_MERIT_ITEM_ID = gql`
  mutation removeCounterpartyMeritItemId($clientId: String!) {
    invoicing {
      removeCounterpartyMeritItemId(clientId: $clientId)
    }
  }
`;

export const SET_COUNTERPARTY_MERIT_TAX_ID = gql`
  mutation setCounterpartyMeritTaxId($clientId: String!, $meritTaxId: String!) {
    invoicing {
      setCounterpartyMeritTaxId(clientId: $clientId, meritTaxId: $meritTaxId)
    }
  }
`;

export const REMOVE_COUNTERPARTY_MERIT_TAX_ID = gql`
  mutation removeCounterpartyMeritTaxId($clientId: String!) {
    invoicing {
      removeCounterpartyMeritTaxId(clientId: $clientId)
    }
  }
`;

export const DELETE_MERIT_INVOICE = gql`
  mutation deleteMeritInvoice($fileId: String!) {
    invoicing {
      deleteMeritInvoice(fileId: $fileId)
    }
  }
`;

export const DELETE_MERIT_PURCHASE_INVOICE = gql`
  mutation DeleteMeritPurchaseInvoice($accountingFileId: UuidType!) {
    accounting {
      deleteMeritPurchaseInvoice(accountingFileId: $accountingFileId)
    }
  }
`;

export const SET_CATEGORY_ITEM_MERIT_ITEM_ID = gql`
  mutation SetCategoryItemMeritItemId($categoryItemId: String!, $meritItemId: String!) {
    bankingCategorization {
      setCategoryItemMeritItemId(categoryItemId: $categoryItemId, meritItemId: $meritItemId)
    }
  }
`;

export const REMOVE_CATEGORY_ITEM_MERIT_ITEM_ID = gql`
  mutation RemoveCategoryItemMeritItemId($categoryItemId: String!) {
    bankingCategorization {
      removeCategoryItemMeritItemId(categoryItemId: $categoryItemId)
    }
  }
`;

export const SET_CATEGORY_ITEM_MERIT_TAX_ID = gql`
  mutation SetCategoryItemMeritTaxId($categoryItemId: String!, $meritTaxId: String!) {
    bankingCategorization {
      setCategoryItemMeritTaxId(categoryItemId: $categoryItemId, meritTaxId: $meritTaxId)
    }
  }
`;

export const REMOVE_CATEGORY_ITEM_MERIT_TAX_ID = gql`
  mutation RemoveCategoryItemMeritTaxId($categoryItemId: String!) {
    bankingCategorization {
      removeCategoryItemMeritTaxId(categoryItemId: $categoryItemId)
    }
  }
`;
